<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>マイページ</h1>
    </div>

    <!-- 警告 -->

    <div class="warning">
      <label *ngIf="1 == needinputList?.memberneedinput">
        <b>（！）</b>会員プロフィールに未登録項目があります。<div class="tooltip-text" (click)="moveB211orMoveB212()">プロフィールの更新</div>
        を行ってください。<br />
      </label>
    </div>
    <div class="warning">
      <label *ngIf="1 == needinputList?.suggestneedreply">
        <b>（！）</b>検討状況が未回答の提案・提案依頼があります。<div class="tooltip-text" (click)="moveC502()">提案・依頼一覧</div>から確認をしてください。<br />
      </label>
    </div>

    <!-- マイページボタンエリア -->
    <div class="p-d-flex p-jc-center my-page-button-area">
      <div class="button-area pre-line">
        <button pButton type="button" label="課題・ソリューション
          登録・管理" icon="pi pi-copy" class="my-page-button3" (click)="moveC104()"></button>
      </div>
      <div class="button-area">
        <label *ngIf="1 == needinputList?.suggestneedreply">
          <button pButton type="button" label="提案・依頼一覧" icon="pi pi-users" class="my-page-button2" (click)="moveC502()">
            <div class="pi pi-exclamation-circle p-button-icon3"></div>
          </button>
        </label>
        <label *ngIf="0 == needinputList?.suggestneedreply">
          <button pButton type="button" label="提案・依頼一覧" icon="pi pi-users" class="my-page-button2"
            (click)="moveC502()"></button>
        </label>
      </div>
      <div class="button-area">
        <button pButton type="button" label="連携事例
        登録・管理" icon="pi pi-link" class="my-page-button" (click)="moveH104()"></button>
      </div>
      <div class="button-area">
        <button pButton type="button" label="イベント・お知らせ
        登録・管理" icon="pi pi-calendar" class="my-page-button" (click)="moveE103()"></button>
      </div>
      <!-- ※準備中を表示するために一旦、課題登録ボタンエリアclassに修正 -->
      <div class="button-area pre-line">
        <button pButton type="button" label="分科会
        設置登録・管理" icon="pi pi-comments" class="my-page-button" (click)="moveE203()"></button>
      </div>
    </div>

    <!-- 課題・ソリューションツールチップ -->
    <div class="info-tooltip-area">
      <div class="tooltip-text">
        <i class="pi pi-info-circle"></i>
        <input id="swich1" class="swich_setting" type="checkbox">
        <label class="tooltip-text" for="swich1">
          課題・ソリューションとは
          <span class="info-description pre-line">
            「課題」とは、主に地方公共団体における、ＳＤＧｓ達成等の地域の将来像を実現するための地域内の困りごとです。<br>
            「ソリューション」とは、主に民間団体等が有する、課題解決に貢献できる可能性がある技術やノウハウ等の総称です。
          </span>
        </label>
      </div>
    </div>

    <!-- 課題・ソリューション・連携事例登録ボタンエリア -->
    <div class="p-d-flex p-jc-center insert-task-button-area">
      <div class="task-button-area">
        <button pButton type="button" label="課題を登録する" class="my-task-button1" (click)="moveC101(1)"></button>
      </div>
      <div class="task-button-area">
        <button pButton type="button" label="ソリューションを登録する" class="my-task-button2" (click)="moveC101(2)"></button>
      </div>
      <div class="task-button-area">
        <button pButton type="button" label="連携事例を登録する" class="my-task-button3" (click)="moveH101()"></button>
      </div>
    </div>

    <!-- ユーザ管理・資料一覧ボタンエリア-->
    <div class="p-d-flex p-jc-center user-menu-link-button-area">
      <div class="menu-link-button-area">
        <label *ngIf="1 == needinputList?.memberneedinput">
          <button pButton type="button" label="会員プロフィール管理" icon="pi pi-id-card" class="menu-link-button"
            (click)="moveB211orMoveB212()">
            <span class="pi pi-exclamation-circle p-button-icon2"></span>
          </button>
        </label>
        <label *ngIf="0 == needinputList?.memberneedinput">
          <button pButton type="button" label="会員プロフィール管理" icon="pi pi-id-card" class="menu-link-button"
            (click)="moveB211orMoveB212()">
          </button>
        </label>
      </div>
      <div class="menu-link-button-area">
        <button pButton type="button" label="ユーザー管理" icon="pi pi-user-plus" class="menu-link-button"
          (click)="moveB220()"></button>
      </div>
      <div class="menu-link-button-area">
        <button pButton type="button" label="資料一覧" icon="pi pi-pencil" class="menu-link-button"
          onclick="location.href='/docs.html'"></button>
      </div>
    </div>

    <!-- レコメンド -->
    <div class="recommend-contents" *ngIf="resultRecommendList?.length != 0">
      <!-- 小タイトル -->
      <h2>関連する課題・ソリューション・連携事例</h2>
      <div class="recommend-border">
        <p-table [value]="resultRecommendList" styleClass="p-datatable-striped" emptyMessage="データが存在しません"
          [autoLayout]="true" [scrollable]="true" scrollHeight="134px" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr class="update-data-header">
              <th class="kbn">種別</th>
              <th class="title">タイトル</th>
              <th class="user">会員名</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-resultRecommend>
            <tr class="update-data" (click)="moveScreenRecommend(resultRecommend)">
              <!-- 種別 -->
              <td class="kbn">
                <!-- 区分が1の場合 -->
                <p-tag value="課題" styleClass="tag task-tag" *ngIf="1 == resultRecommend?.kbn"></p-tag>
                <!-- 区分が2の場合 -->
                <p-tag value="ソリューション" styleClass="tag solution-tag" *ngIf="2 == resultRecommend?.kbn"></p-tag>
                <!-- 区分が1,2以外の場合 -->
                <p-tag value="連携事例" styleClass="tag jirei-tag" *ngIf="3 == resultRecommend?.kbn"></p-tag>
              </td>
              <!-- タイトル -->
              <td class="title">{{ resultRecommend?.title }}</td>
              <!-- 会員名 -->
              <td class="user">{{ resultRecommend?.organization_name }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- 最近の更新 -->
    <div class="update-contents">
      <!-- 小タイトル -->
      <h2>最近の更新（最近1ヶ月）</h2>

      <p-table [value]="updateDataList" styleClass="p-datatable-striped" emptyMessage="データが存在しません"
        [autoLayout]="true" [scrollable]="true" scrollHeight="134px" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr class="update-data-header">
            <th class="point">更新箇所</th>
            <th class="user">会員名称</th>
            <th class="update-user">更新会員名称</th>
            <th class="date">更新日時</th>
            <th class="contents">更新内容</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-updateData>
          <tr class="update-data" (click)="moveScreen(updateData)">
            <!-- 更新箇所 -->
            <td class="point">
              {{ updateData.change_place }}
            </td>
            <!-- 会員名称 -->
            <td class="user">
              {{ updateData.member_id.name }}
            </td>
            <!-- 更新会員名称 -->
            <td class="update-user">
              {{ updateData.member_id2.name }}
            </td>
            <!-- 更新日時 -->
            <td class="date">
              {{ updateData.edit_datetime_src }}
            </td>
            <!-- 更新内容 -->
            <td class="contents-data">
              {{ updateData.change }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- システムに関するお知らせ -->
    <div class="notice-contents">
      <!-- 小タイトル -->
      <h2>システムに関するお知らせ</h2>

      <p-table [value]="noticeDataList" styleClass="p-datatable-striped"
               [autoLayout]="true" [scrollable]="true" scrollHeight="134px" responsiveLayout="scroll">
        <ng-template pTemplate="body" let-noticeData>
          <tr class="notice-data">
            <!-- 日時 -->
            <td class="date">
              {{ noticeData.create_datetime }}
            </td>
            <!-- 内容 -->
            <td class="contents">
              {{ noticeData.information_detail }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 自治体の声 -->
    <div class="article-contents">
      <!-- 小タイトル -->
      <h2>自治体の声</h2>
      <p-dataView
        #article_table
        [value]="articleDataList"
        [rows]="4"
        emptyMessage="データが存在しません"
        layout="grid"
      >
        <!-- グリッドアイテム -->
        <ng-template let-resultArticleData pTemplate="gridItem">
          <div
            class="p-col-12 p-md-3 article-item"
            [ngClass]="{'filler': resultArticleData?.is_filler}">
            <a
              *ngIf="!resultArticleData?.is_filler"
              class="item-area item"
              [attr.href]="resultArticleData?.article_url"
              style="text-decoration:none; color: inherit;"
              target="_blank">
              <div class="article-new-tag-container" *ngIf="isWithinLastMonth(resultArticleData?.update_datetime)">
                <p-tag value="NEW" styleClass="article-new-tag"></p-tag>
              </div>
              <div class="image">
                <img
                  [src]="resultArticleData?.article_image.file_path"
                  alt="image"
                />
              </div>
              <div class="title">{{ resultArticleData.title }}</div>
              <div class="description">{{ resultArticleData.description }}</div>
            </a>
            <div *ngIf="resultArticleData?.is_filler" class="item-area item">
              <div class="image filler"></div>
              <div class="title"></div>
              <div class="description"></div>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>

  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
